/*
 * The way out of a sold-out size.
 *
 * WHAT IT WATCHES
 *
 * Dawn marks an unavailable option value with class="disabled" on the radio,
 * not the disabled attribute, so the input is still selectable and selecting
 * it is what puts the buy button into "Unavailable". That is the moment this
 * listens for. It does not intercept the click: the shopper still gets the
 * theme's own behaviour, and gets an offer underneath it.
 *
 * It also fires with no click at all when every size is gone, because there
 * the shopper never gets as far as choosing one.
 *
 * WHAT IT ASKS
 *
 * The product's own title and the size the shopper just tried, which are the
 * two facts the index can act on: option1 carries sizes and title carries the
 * name. Nothing here invents an attribute the catalogue does not hold.
 *
 * WHY NO SDK LOADING
 *
 * The product page already loads az-chat-sdk.js through the app's az-chat-pdp
 * block. Fetching a second copy would be a second widget. So this waits for
 * window.AtomzChat and, if it never arrives, removes its own button rather
 * than leaving one that does nothing -- a button that does nothing is the
 * thing this feature exists to remove.
 */
(function () {
  'use strict';

  var WAIT_MS = 12000;
  var POLL_MS = 150;

  function mount() { return document.querySelector('[data-az-soldout]'); }

  function radios() {
    return document.querySelectorAll('.product-form__input input[type="radio"]');
  }

  // A value is gone when Dawn says so, either way round: the class it adds
  // for a visually-disabled option, or a real disabled attribute.
  function gone(input) {
    return input.classList.contains('disabled') || input.disabled;
  }

  function allGone() {
    var r = radios();
    if (!r.length) return false;
    for (var i = 0; i < r.length; i++) if (!gone(r[i])) return false;
    return true;
  }

  function chat() {
    return new Promise(function (resolve, reject) {
      if (window.AtomzChat) return resolve(window.AtomzChat);
      var waited = 0;
      var t = window.setInterval(function () {
        if (window.AtomzChat) { window.clearInterval(t); resolve(window.AtomzChat); return; }
        waited += POLL_MS;
        if (waited >= WAIT_MS) { window.clearInterval(t); reject(new Error('no AtomzChat')); }
      }, POLL_MS);
    });
  }

  function question(title, optionName, size) {
    if (size) {
      return 'The ' + title + ' is sold out in ' + optionName.toLowerCase() + ' ' + size +
        '. What else do you have like it in that size?';
    }
    return 'The ' + title + ' is sold out. What else do you have like it?';
  }

  function render(host, title, optionName, size) {
    var line = size
      ? optionName + ' ' + size + ' is sold out.'
      : 'This one is sold out.';

    host.textContent = '';
    var p = document.createElement('p');
    p.className = 'az-soldout__line';
    p.textContent = line;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'az-soldout__ask';
    btn.textContent = size ? 'Find it in ' + optionName.toLowerCase() + ' ' + size : 'Find something like it';

    host.appendChild(p);
    host.appendChild(btn);
    host.hidden = false;

    btn.addEventListener('click', function () {
      chat().then(function (c) { c.open(question(title, optionName, size)); }).catch(function () {
        // The widget never arrived. Send them somewhere real rather than
        // leaving a button that swallows the tap.
        window.location.href = '/search?q=' + encodeURIComponent(title);
      });
    });
  }

  function start() {
    var host = mount();
    if (!host) return;
    var title = host.getAttribute('data-product-title') || '';
    var optionName = host.getAttribute('data-option-name') || 'Size';
    if (!title) return;

    // Nothing is offered until the widget is known to be there, so the page
    // never shows a way out that does not go anywhere.
    chat().then(function () {
      if (allGone()) { render(host, title, optionName, null); return; }

      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.type !== 'radio' || !t.closest('.product-form__input')) return;
        if (gone(t)) render(host, title, optionName, t.value);
        else { host.hidden = true; host.textContent = ''; }
      });
    }).catch(function () { /* no widget on this page; leave it as it was */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
